import { SVGProps } from "react";

const CalendarTasksIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_750_1573)">
        <path
          d="M0.70208 18.6045H19.0779C19.2427 18.6045 19.402 18.5468 19.5283 18.4418C19.7048 18.2939 23.731 14.8304 23.9765 7.354H4.24121C3.99665 14.1406 0.288765 17.3305 0.250232 17.3623C0.0243312 17.5532 -0.0587819 17.865 0.0428476 18.1424C0.143774 18.4191 0.406801 18.6045 0.70208 18.6045Z"
          fill="#43454E"
        />
        <path
          d="M23.2977 3.13532H19.7819V2.43216C19.7819 2.03839 19.4726 1.729 19.0788 1.729C18.685 1.729 18.3756 2.03839 18.3756 2.43216V3.13532H14.813V2.43216C14.813 2.03839 14.5036 1.729 14.1098 1.729C13.7161 1.729 13.4067 2.03839 13.4067 2.43216V3.13532H9.89088V2.43216C9.89088 2.03839 9.58149 1.729 9.18772 1.729C8.79395 1.729 8.48456 2.03839 8.48456 2.43216V3.13532H4.96878C4.57501 3.13532 4.26562 3.44471 4.26562 3.83847V5.94794H24.0009V3.83847C24.0009 3.44471 23.6915 3.13532 23.2977 3.13532Z"
          fill="#43454E"
        />
        <path
          d="M20.4322 19.5205C20.0504 19.8384 19.5711 20.0115 19.0788 20.0115H4.26562V22.121C4.26562 22.5096 4.58012 22.8241 4.96878 22.8241H23.2977C23.6864 22.8241 24.0009 22.5096 24.0009 22.121V14.2388C22.6452 17.5647 20.7534 19.2517 20.4322 19.5205Z"
          fill="#43454E"
        />
      </g>
      <defs>
        <clipPath id="clip0_750_1573">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.275879)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CalendarTasksIcon;
